import React from "react";
import cancel from "../../Assets/Images/cancel.svg";
import "../../Assets/Styles/pages/cancel_button.scss";

const CancelButton = (props) => {
  return (
    <div className="cancel_button d-flex justify-content-end">
      <img alt="Cancel Button" src={cancel} onClick={() => props.close()} />
    </div>
  );
};
export default CancelButton;
